import React from "react";
import "../styles/AdmissionInfo.css";
import { FaFilePdf } from "react-icons/fa";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// PDF file
import Admission_Info from "../Assets/Pdfs/Admission_info.pdf";

export default function AdmissionInfo() {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <div className="admission-info-page">
            <section className="admission-info-section pdf-section">
                <h2>
                    <FaFilePdf className="pdf-icon" /> Admission Information
                </h2>

                {/* PDF Viewer */}
                <div className="pdf-viewer">
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <Viewer
                            fileUrl={Admission_Info}
                            plugins={[defaultLayoutPluginInstance]}
                        />
                    </Worker>
                </div>

                {/* Download link */}
                <p className="pdf-download">
                    <a
                        href={Admission_Info}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Download Admission Information
                    </a>
                </p>
            </section>

            <footer className="admission-info-footer">
                <p>
                    Thank you for your interest in Akij Foundation Vocational School.  
                    Please read the admission guidelines carefully before applying.
                </p>
            </footer>
        </div>
    );
}
